import Block from './Component';
import renderFrontend from '../helpers/render-frontend';
import { TimelineProps } from 'components/section/Timeline/Timeline';

const getProps = (el: HTMLElement): TimelineProps => {
  if (!JSON.parse(el.dataset?.items)) {
    return {
      items: [],
    };
  }

  const items = JSON.parse(el.dataset.items) as TimelineProps['items'];

  return {
    items,
  };
};

renderFrontend({
  Block: Block as any,
  getProps,
  selector: '.wp-block-create-block-timeline',
});
